import {
  CircularProgress,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

import { AuthContext } from "context";
import 'dayjs/locale/it';
import { createMRTColumnHelper } from "material-react-table";
import toast from 'react-hot-toast';
import MDButton from "../../components/MDButton";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import GenericTable from "../genericTable";


const ConcreteResultManagment = () => {
  const navigate = useNavigate();
  const authContext = React.useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);

  const columnHelper = createMRTColumnHelper();

  useEffect(() => {
      fetchDocument();
  }, []);

  const fetchDocument = async (docId) => {
    setLoading(true);
     apiService.get("/concrete-result/",{id_area: localStorage.getItem("areaSelected")} ,{} )
      .then((response) => {
        if (response)
          setDocuments(response)
      })
      .catch((error) => {
        toast.error('Errore durante la chiamata al server, codice d\'errore #08514262429906', {id: 'concrete-result-managment-toast'});
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onEdit = (id) => {
    window.location.href = "/concrete-result-managment/edit/" + id + "/";
  };

  const columns = [
    columnHelper.accessor('date', {
      header: 'Data',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('name_tech', {
      header: 'Tecnico responsabile',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('withdrawal', {
      header: 'Getto',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('cubes_identification', {
      header: 'Cubo',
      size: 100,
      enableSorting: true,
      enableColumnFilterModes: true,
    }),
    columnHelper.accessor('url', {
      header: 'Risultato',
      size: 100,
      enableSorting: false,
      enableColumnFilterModes: false,
      enableColumnFilter: false,
      Cell: ({ cell }) => (
        <MDButton
          onClick={() => window.open(cell.getValue(), '_blank')}
          size="small"
        > Vedi Documento </MDButton>
      )
    }),
  ]

  async function deleteResource(id) {
          try {
            // Costruisci l'endpoint usando l'id fornito
            const endpoint = `/concrete-result/`;

            // Parametri opzionali per la richiesta DELETE
            const params = {id:id}; // Puoi aggiungere parametri se necessario
            const headers = {}; // Headers opzionali

            // Esegui la chiamata DELETE
            const response = await apiService.delete(endpoint, params, headers);

            // Se arriviamo qui, la chiamata è andata a buon fine
            console.log(`Risorsa con id ${id} eliminata con successo:`, response);

            // Puoi fare qualcosa con la risposta, se necessario
            return response;

          } catch (error) {
            // Gestisci eventuali errori
            console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

            // Puoi gestire l'errore in modo specifico, ad esempio:
            if (error.message.includes('404')) {
              console.log(`La risorsa con id ${id} non è stata trovata`);
            } else if (error.message.includes('403')) {
              console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
            }

            // Rilancia l'errore se vuoi che venga gestito a un livello superiore
            throw error;
          }
        }

      function handleDelete(id) {
          if(window.confirm("Sei sicuro di voler eliminare questo risultato?\n Attenzione questa operazione è irreversibile.")) {
          deleteResource(id)
              .then(result => {
                  toast.success("Risultato eliminato con successo", {id: 'concrete-result-managment-toast'})
                  fetchDocument()
              })
              .catch(error => {
                  toast.error("Si è verificato un errore durante l'eliminazione del risultato. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032", {id: 'concrete-result-managment-toast'})
              });
          }
      }

  return (
    <DashboardLayout>
      <DashboardNavbar />
        {!loading ?
          <>
            <center>
              <Typography variant="h4" sx={{ marginTop: "20px" }}>Elenco risultati laboratorio</Typography>
              {authContext.hasAuth("UPDATE_CONCRETERESULT") && <MDButton
                onClick={() => navigate("/concrete-result-managment/add/")}
                size="large" sx={{ marginTop: "20px", marginBottom: "20px" }}> AGGIUNGI</MDButton>}
              <GenericTable
                data={documents}
                columns={columns}
                onEdit = {onEdit}
                onDelete = {handleDelete}
                authModelName="CONCRETERESULT"

              />
            </center>
          </>
          :
          <center>
            <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/>
          </center>
        }
    </DashboardLayout>

  );
};

export default ConcreteResultManagment;